import { render, staticRenderFns } from "./TaskBand.vue?vue&type=template&id=9e4f2860&scoped=true"
import script from "./TaskBand.vue?vue&type=script&lang=js"
export * from "./TaskBand.vue?vue&type=script&lang=js"
import style0 from "./TaskBand.vue?vue&type=style&index=0&id=9e4f2860&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e4f2860",
  null
  
)

export default component.exports